<div [innerHTML]="iconSvg" class="icon-wrapper"></div>